import { h, Component } from 'preact';
import { translate } from 'react-i18next';

import Button from './Button.js';


class TwoFactorPhone extends Component {

  addPhone = () => {
  	this.setState({ buttonEnterPhone: 'loading' });
  	if (this.props.country && this.props.countryCode) {
  		if (this.state.phone) {
				fetch('https://api.hirezstudios.com/acct/addMobileNumber', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "countryCode": "${this.props.country}", "mobileNumber": "${this.state.phone}"}`
				}).then((response) => response.json()).then((response) => {
					this.setState({ buttonEnterPhone: 'initial' });
					if (response.statusCode === 200) {
						this.setState({ step: 'verify' });
					} else {
						this.setState({ errorEnterPhone: 'Something went wrong. Please try again.' });
					}
				})
  		}
  		else {
  			this.setState({
					buttonEnterPhone: 'initial',
					errorEnterPhone: 'A phone number is required.'
				});
  		}
  	}
  	else {
  		this.setState({
				buttonEnterPhone: 'initial',
				errorEnterPhone: 'A country must be selected above.'
			});
  	}
	}

  verifyPhone = () => {
  	this.setState({ buttonVerifyPhone: 'loading' });
  	if (this.state.phoneCode) {
  		fetch('https://api.hirezstudios.com/acct/validateMobilePhone', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: `{"webToken": "${this.props.userData.webToken}", "code": "${this.state.phoneCode}"}`
				}).then((response) => response.json()).then((response) => {
					this.setState({ buttonVerifyPhone: 'initial' });
					if (response.statusCode === 200) {
						this.setState({ step: 'confirmed' });
						this.props.update('newPhone',this.state.phone);
					} else {
						this.setState({ errorVerifyPhone: 'Please check your validation code and try again.' });
					}
				})
    }
  	else {
  		this.setState({
				buttonVerifyPhone: 'initial',
				errorVerifyPhone: 'A verification code is required.'
			});
  	}
  }

  cancelVerify = () => {
  	this.setState({
			step: 'initial',
			phone: undefined,
			phoneCode: undefined,
			errorVerifyPhone: undefined,
			errorEnterPhone: undefined
		});
  }

  constructor(props) {
  	super(props);
  	this.state = {
  		step: 'initial',
  		buttonEnterPhone: 'initial',
  		buttonVerifyPhone: 'initial'
  	};
	}

  componentDidMount() {
      this.setState({ currentPhone: this.props.twoFactorData.phone !== null ? this.props.twoFactorData.phone : '' });
	}
	
	shouldComponentUpdate(nextProps) {
    if ( nextProps.twoFactorData !== undefined && this.state.currentPhone === undefined && nextProps.twoFactorData.phonne !== null ) {
      this.setState({ currentPhone: nextProps.twoFactorData.phone });
    }
  }

  render() {
		const { t } = this.props;
  	return (
  		<div className="c-TwoFactorPhone">
  			<h4>{t('Phone Number Verification Settings')}</h4>
				<div className={`sms-warning ${this.state.step === 'confirmed' ? 'is-hidden' : ''}`}>{t('Only select countries can receive our SMS alerts. Normal SMS charges apply.')}</div>
				{ this.state.step === 'initial' && this.state.currentPhone !== undefined &&
					<div className="current-phone-notification">{t(`Currently using ${this.state.currentPhone} as your phone number.`)}</div>
				}
  			{ this.state.step === 'initial' &&
            <div>
            	<div className="enter-phone">
            		<label>{t('Enter Phone Number:')}</label>
								<div className="input-wrapper">
								<div className="country-code">{this.props.countryCode}</div>
									<input
										key="enter-phone"
										id="enter-phone"
										type="text"
										onInput={e => this.setState({ phone: e.target.value })}
										value={this.state.phone}
									/>
            			<div className="error-enter-phone">{t(this.state.errorEnterPhone)}</div>
            		</div>
            	</div>
            	<div className="buttons-wrapper">
								<Button
									color="blue"
									copy={t('Next')}
									state={this.state.buttonEnterPhone}
									onClick={this.addPhone}
								/>
            	</div>
            </div>
  			}
  			{ this.state.step === 'verify' &&
            <div>
            	<div className="verify-phone">
            		<label>{t('Verification Code:')}</label>
            		<div className="input-wrapper">
									<input
										key="verify-phone"
										id="verify-phone"
										type="text"
										onInput={e => this.setState({ phoneCode: e.target.value })}
										value={this.state.phoneCode}
									/>
            			<div className="error-verify-phone">{t(this.state.errorVerifyPhone)}</div>
            		</div>
            	</div>
            	<div className="buttons-wrapper">
								<Button
									color="blue"
									copy={t('Verify')}
									state={this.state.buttonVerifyPhone}
									onClick={this.verifyPhone}
								/>
								<Button
									copy={t('Cancel')}
									onClick={this.cancelVerify}
								/>
            	</div>
            </div>
				}
				{ this.state.step === 'confirmed' &&
					<div>
						<div className="confirmed-phone">
							<div className="confirm-message">{t('You\'ve successfully verified your mobile phone number.')} <a onClick={this.cancelVerify}>{t('Click here')}</a> {t('to add a new phone number.')}</div>
						</div>
					</div>
				}
  		</div>
  	);
  }
}

export default translate(['common'], { withRef: true })(TwoFactorPhone);


// WEBPACK FOOTER //
// ./components/TwoFactorPhone.js